@if (isReady) {
<div id="sidebar">
  <header>
    <h2>{{ "settings.components" | transloco }}</h2>
    <div class="ui pointing secondary menu">
      <div
        class="item categories"
        (click)="activeTab = 'categories'"
        [ngClass]="{ active: activeTab === 'categories' }"
      >
        {{ "settings.categories" | transloco }}
      </div>
      <div
        class="item sub-categories"
        (click)="activeTab = 'sub-categories'"
        [ngClass]="{ active: activeTab === 'sub-categories' }"
      >
        {{ "settings.subcategories" | transloco }}
      </div>
      <div
        class="item subgroups"
        (click)="activeTab = 'subgroups'"
        [ngClass]="{ active: activeTab === 'subgroups' }"
      >
        {{ "settings.subgroups" | transloco }}
      </div>
      <div
        class="item questions"
        (click)="activeTab = 'questions'"
        [ngClass]="{ active: activeTab === 'questions' }"
      >
        {{ "settings.questions" | transloco }}
      </div>
    </div>
  </header>
  <div
    class="ui tab categories"
    [ngClass]="{ active: activeTab === 'categories' }"
  >
    <div class="tab-contents">
      <div class="content hidden-scrollbar">
        <div class="header">
          <div class="search">
            <div class="ui left icon input">
              <i class="search icon"></i>
              <input
                id="category-search"
                type="text"
                [(ngModel)]="categorySearch"
                placeholder="{{ 'settings.search-categories' | transloco }}"
              />
            </div>
          </div>
          @if (!isProductionMode) {
          <div (click)="showCreateCategoryModal()" class="ui primary button">
            {{ "settings.create-new" | transloco }}
          </div>
          }
        </div>
        @if (categories?.length > 0) {
        <div class="list">
          @for (category of categories|keyWord:['name']:categorySearch; track
          category) {
          <div class="item">
            {{ category?.name }}
          </div>
          }
        </div>
        } @if (categories?.length === 0) {
        <div
          *ngTemplateOutlet="noResults; context: { type: 'categorie' }"
        ></div>
        }
      </div>
    </div>
  </div>
  <div
    class="ui tab subcategories"
    [ngClass]="{ active: activeTab === 'sub-categories' }"
  >
    <div class="tab-contents">
      <div class="content hidden-scrollbar">
        <div class="header">
          <div class="search">
            <div class="ui left icon input">
              <i class="search icon"></i>
              <input
                id="subcategory-search"
                type="text"
                [(ngModel)]="subcategorySearch"
                placeholder="{{ 'settings.search-subcategories' | transloco }}"
              />
            </div>
          </div>
          @if (!isProductionMode) {
          <div (click)="showCreateSubcategoryModal()" class="ui primary button">
            {{ "settings.create-new" | transloco }}
          </div>
          }
        </div>
        @if (subcategories?.length > 0) {
        <div class="list">
          @for (subcategory of subcategories|keyWord:['name']:subcategorySearch;
          track subcategory) {
          <div class="item">
            {{ subcategory?.name }}
          </div>
          }
        </div>
        } @if (subcategories?.length === 0) {
        <div
          *ngTemplateOutlet="noResults; context: { type: 'subcategorie' }"
        ></div>
        }
      </div>
    </div>
  </div>
  <div
    class="ui tab subgroups"
    [ngClass]="{ active: activeTab === 'subgroups' }"
  >
    <div class="tab-contents">
      <div class="content hidden-scrollbar">
        <div class="header">
          <div class="search">
            <div class="ui left icon input">
              <i class="search icon"></i>
              <input
                id="subgroup-search"
                type="text"
                [(ngModel)]="subgroupSearch"
                placeholder="{{ 'settings.search-subgroups' | transloco }}"
              />
            </div>
          </div>
          @if (!isProductionMode) {
          <div (click)="showCreateSubgroupModal()" class="ui primary button">
            {{ "settings.create-new" | transloco }}
          </div>
          }
        </div>
        @if (subgroups?.length > 0) {
        <div class="list">
          @for (subgroup of subgroups|keyWord:['name']:subgroupSearch; track
          subgroup) {
          <div class="item">
            {{ subgroup?.name }}
          </div>
          }
        </div>
        } @if (subgroups?.length === 0) {
        <div *ngTemplateOutlet="noResults; context: { type: 'subgroup' }"></div>
        }
      </div>
    </div>
  </div>
  <div
    class="ui tab questions"
    [ngClass]="{ active: activeTab === 'questions' }"
  >
    <div class="tab-contents">
      <div class="content hidden-scrollbar">
        <div class="header">
          <div class="search">
            <div class="ui left icon input">
              <i class="search icon"></i>
              <input
                id="question-search"
                type="text"
                [(ngModel)]="questionSearch"
                placeholder="{{ 'settings.search-questions' | transloco }}"
              />
            </div>
          </div>
          @if (!isProductionMode) {
          <a
            [routerLink]="['/settings/global', 'questions', 'new']"
            target="_blank"
            class="ui primary button"
            >{{ "settings.create-new" | transloco }}</a
          >
          }
        </div>
        @if (questions?.length > 0) {
        <div class="list">
          @for (question of questions|keyWord:['question']:questionSearch; track
          question) {
          <div class="item">
            @if (showQuestionId) {
            <span>{{ question?.id }}.</span>
            } {{ question?.question }}
          </div>
          }
        </div>
        } @if (questions?.length === 0) {
        <div *ngTemplateOutlet="noResults; context: { type: 'question' }"></div>
        }
      </div>
    </div>
  </div>
</div>
} @if (isReady) {
<div id="content" class="hidden-scrollbar">
  <header>
    <h2>{{ "settings.global-form-structure" | transloco }}</h2>
    <div>
      <div
        (click)="syncCache()"
        class="ui primary button"
        [ngClass]="{ loading: isSyncingCache }"
      >
        {{ "settings.sync-global-cache" | transloco }}
      </div>
      @if (!isProductionMode) {
      <div
        (click)="save()"
        class="ui primary save button"
        [ngClass]="{ loading: isSaving }"
      >
        {{ "settings.save" | transloco }}
      </div>
      }
    </div>
  </header>
  <div id="body">
    <div id="form-structure">
      @for (category of categories; track category; let i = $index) {
      <div class="listing">
        <div
          (click)="selectCategory(category, i)"
          class="category item"
          [ngClass]="{ selected: selectedNode?.category?.id === category?.id }"
        >
          <div>{{ category.name }}</div>
          <div>
            <div class="count">
              {{ category.subcategories?.length || 0 }}
              {{
                category.subcategories?.length === 1
                  ? "Subcategory"
                  : "Subcategories"
              }}
            </div>
            <div [ngClass]="{ hidden: category.subcategories?.length === 0 }">
              <i
                class="chevron icon"
                [ngClass]="{
                  down: category.isCollapsed,
                  up: !category.isCollapsed
                }"
              ></i>
            </div>
          </div>
          <div
            (click)="showConfirmDeleteModal('category', category)"
            class="delete"
            [ngClass]="{ hidden: category.id }"
          >
            <div class="delete icon"></div>
          </div>
          <div class="order">
            {{ category.order == null ? "null" : category.order }}.
          </div>
        </div>
        @if (category.subcategories?.length > 0 && !category?.isCollapsed) {
        <div class="listing">
          @if (category.isLoading) {
          <div>
            <div class="ui active centered inline loader"></div>
          </div>
          } @if (!category.isLoading) {
          <div>
            @for (subcategory of category?.subcategories; track subcategory) {
            <div
              (click)="editNode(null, subcategory)"
              class="subcategory item"
              [ngClass]="{
                selected: selectedNode?.subCategory?.id === subcategory.id
              }"
            >
              <div>
                {{ subcategory.name }}
              </div>
              <div>
                <div>
                  @if (subcategory.tabQuestion) {
                  <div class="tab-lbl">Tab</div>
                  }
                </div>
                <div class="count">
                  {{ subcategory.subgroups?.length || 0 }}
                  {{
                    subcategory.subgroups?.length === 1
                      ? "Subgroup"
                      : "Subgroups"
                  }}
                </div>
                <div
                  [ngClass]="{ hidden: subcategory.subgroups?.length === 0 }"
                >
                  <i
                    class="chevron icon"
                    [ngClass]="{
                      down: subcategory.isCollapsed,
                      up: !subcategory.isCollapsed
                    }"
                  ></i>
                </div>
              </div>
              <div
                (click)="showConfirmDeleteModal('subCategory', subcategory)"
                class="delete"
                [ngClass]="{ hidden: subcategory.id }"
              >
                <div class="delete icon"></div>
              </div>
              <div class="order">
                {{ subcategory.order == null ? "null" : subcategory.order }}.
              </div>
            </div>
            @for (subgroup of subcategory?.subgroups; track subgroup) { @if
            (subcategory.subgroups?.length > 0 && !subcategory.isCollapsed) {
            <div class="listing">
              <div
                (click)="editNode(null, null, subgroup)"
                class="subgroup item"
                [ngClass]="{
                  selected: selectedNode?.subGroup?.id === subgroup?.id
                }"
              >
                <div>
                  {{ subgroup?.name }}
                  <div class="subgroup-hash">#{{ subgroup?.hash }}</div>
                </div>
                <div>
                  <div class="count">
                    {{ subgroup.questions?.length || 0 }}
                    {{
                      subgroup.questions?.length === 1
                        ? "Question"
                        : "Questions"
                    }}
                  </div>
                  <div [ngClass]="{ hidden: subgroup.questions?.length === 0 }">
                    <i
                      class="chevron icon"
                      [ngClass]="{
                        down: subgroup.isCollapsed,
                        up: !subgroup.isCollapsed
                      }"
                    ></i>
                  </div>
                </div>
                <div
                  (click)="showConfirmDeleteModal('subGroup', subgroup)"
                  class="delete"
                  [ngClass]="{ hidden: subgroup.id }"
                >
                  <div class="delete icon"></div>
                </div>
                <div class="order">
                  {{ subgroup.order == null ? "null" : subgroup.order }}.
                </div>
              </div>
              @if (subgroup.questions?.length > 0 && !subgroup.isCollapsed) {
              <div class="listing">
                @for (question of subgroup.questions; track question) {
                <div
                  class="question item"
                  [ngClass]="{
                    selected: selectedNode?.question?.id === question?.id,
                    'column-q': question.parentId
                  }"
                  (click)="editNode(null, null, null, question)"
                >
                  <div class="question-lbl">
                    <div class="question">
                      @if (showQuestionId) {
                      <span>{{ question.id }}.</span>
                      } {{ question.question }}
                      <div class="question-type">
                        {{ getQuestionType(question) }}
                      </div>
                    </div>
                    <div class="dep-mandatory-lbl">
                      @if (question.dependantMandatoryParentId) {
                      <span
                        title="This question is only mandatory dependant on another question"
                        >D</span
                      >
                      }
                    </div>
                    <div class="hidden-lbl">
                      @if (question.hidden) {
                      <span title="This is a hidden question">H</span>
                      }
                    </div>
                  </div>
                  <div class="mandatory">
                    {{ question.mandatory ? "Mandatory" : "Optional" }}
                  </div>
                  <div
                    class="top-level"
                    title="This is a {{
                      question.topLevel ? 'a' : 'not a'
                    }} top level question"
                  >
                    <span
                      class="dot"
                      [ngClass]="{ active: question.topLevel }"
                    ></span>
                  </div>
                  <div
                    class="delete"
                    (click)="
                      showConfirmDeleteModal('question', question, subgroup)
                    "
                    [ngClass]="{ hidden: !question.canRemove }"
                  >
                    <div class="delete icon"></div>
                  </div>
                  <div class="order">
                    {{ question.order == null ? "null" : question.order }}.
                  </div>
                </div>
                }
              </div>
              }
            </div>
            } } }
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    <div id="settings">
      @if (!selectedNode?.category && !selectedNode?.subCategory &&
      !selectedNode?.subGroup && !selectedNode?.question && !isProductionMode) {
      <div (click)="showCreateCategoryModal()" class="ui primary button">
        {{ "settings.add-category" | transloco }}
      </div>
      } @if (selectedNode?.category) {
      <div>
        <header>
          <div class="sub-title">{{ "settings.category" | transloco }}</div>
          <div>
            <h3>{{ selectedNode?.category?.name }}</h3>
            @if (!isProductionMode) {
            <span (click)="showEditModal()" class="edit-btn">{{
              "settings.edit" | transloco
            }}</span>
            }
          </div>
          @if (!isProductionMode) {
          <div (click)="showCreateSubcategoryModal()" class="ui primary button">
            {{ "settings.add-subcategory" | transloco }}
          </div>
          }
        </header>
      </div>
      } @if (selectedNode?.subCategory) {
      <div id="subcategory-settings">
        <header>
          <div class="sub-title">{{ "settings.subcategory" | transloco }}</div>
          <div>
            <h3>{{ selectedNode?.subCategory?.name }}</h3>
            @if (!isProductionMode) {
            <span (click)="showEditModal()" class="edit-btn">{{
              "settings.edit" | transloco
            }}</span>
            }
          </div>
        </header>
        @if (!isProductionMode) {
        <div (click)="showCreateSubgroupModal(true)" class="ui primary button">
          {{ "settings.add-subgroup" | transloco }}
        </div>
        }
        <h4>{{ "settings.tab-question-for-this-subcategory" | transloco }}</h4>
        <span class="grey">{{
          selectedNode.subCategory?.tabQuestion?.question || "Not tabbed"
        }}</span>
        @if (selectedNode.subCategory?.tabQuestion?.canEdit &&
        !isProductionMode) {
        <span (click)="showTabQuestionModal()" class="edit-btn">{{
          "settings.edit" | transloco
        }}</span>
        } @if (selectedNode.subCategory?.tabQuestion &&
        selectedNode.subCategory?.tabQuestion?.canEdit) {
        <span
          (click)="selectedNode.subCategory.tabQuestion = null"
          class="edit-btn"
          >{{ "settings.remove" | transloco }}</span
        >
        } @if (!selectedNode.subCategory?.tabQuestion && !isProductionMode) {
        <div style="margin-top:1em">
          <h4>{{ "settings.make-this-a-tabbed-subcategory" | transloco }}</h4>
          <div (click)="showTabQuestionModal()" class="ui primary button">
            {{ "settings.add-tab-question" | transloco }}
          </div>
        </div>
        }
      </div>
      } @if (selectedNode?.subGroup) {
      <div id="subgroup-settings">
        <header>
          <div class="sub-title">{{ "settings.subgroup" | transloco }}</div>
          <div>
            <h3>{{ selectedNode?.subGroup?.name }}</h3>
            @if (!isProductionMode) {
            <span (click)="showEditModal()" class="edit-btn">{{
              "settings.edit" | transloco
            }}</span>
            }
          </div>
          <div class="subgroup-hash">#{{ selectedNode?.subGroup?.hash }}</div>
        </header>
        @if (!isProductionMode) {
        <div
          (click)="showAddQuestionToSubgroupModal()"
          class="ui primary button"
        >
          {{ "settings.add-question-to-subgroup" | transloco }}
        </div>
        }
      </div>
      } @if (selectedNode?.question) {
      <div>
        <header>
          <div class="sub-title">{{ "settings.question" | transloco }}</div>
          <div>
            <h3>{{ selectedNode?.question?.question }}</h3>
            @if (!isProductionMode) {
            <span (click)="showEditModal()" class="edit-btn">{{
              "settings.edit" | transloco
            }}</span>
            }
          </div>
        </header>
      </div>
      }
    </div>
  </div>
</div>
}

<ng-template #noResults let-type="type">
  <div class="no-results">
    {{ 'settings.no-type-s-found' | transloco: {type} }}
  </div>
</ng-template>

<div id="modals-container">
  <div #newCategoryModal id="new-category-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>

    <h1>{{ "settings.create-new-category" | transloco }}</h1>

    <form (ngSubmit)="addCategory()">
      <div>
        <label>{{ "settings.category-name" | transloco }}</label>
        <input type="text" [(ngModel)]="newCategoryName" name="name" />
      </div>

      <div>
        <label>{{ "settings.category-order" | transloco }}</label>
        <input
          type="number"
          min="1"
          [(ngModel)]="newCategoryOrder"
          name="order"
        />
      </div>

      <div class="actions">
        <span class="go-back cancel">{{ "settings.cancel" | transloco }}</span>
        <button
          class="ui primary background button"
          [ngClass]="{ disabled: !newCategoryName }"
        >
          {{ "settings.create" | transloco }}
        </button>
      </div>
    </form>
  </div>

  <div #newSubcategoryModal id="new-subcategory-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>

    @if (!selectedNode?.category) {
    <h3>
      {{
        "settings.you-must-first-select-a-category-to-add-a-new-subcategory"
          | transloco
      }}
    </h3>
    } @if (selectedNode?.category) {
    <h1>{{ "settings.create-new-subcategory" | transloco }}</h1>
    } @if (selectedNode?.category) {
    <form (ngSubmit)="createSubcategory()">
      <div>
        <label>{{ "settings.subcategory-name" | transloco }}</label>
        <input
          type="text"
          [(ngModel)]="newSubcategoryName"
          name="newSubcategoryName"
        />
      </div>
      <div>
        <label>{{ "settings.order" | transloco }}</label>
        <input
          type="number"
          min="1"
          [(ngModel)]="newSubcategoryOrder"
          name="newSubcategoryOrder"
        />
      </div>
      <div class="actions">
        <span class="go-back cancel">{{ "settings.cancel" | transloco }}</span>
        <button
          class="ui primary background button"
          [ngClass]="{ disabled: !newSubcategoryName }"
        >
          {{ "settings.create" | transloco }}
        </button>
      </div>
    </form>
    }
  </div>

  <div #newSubgroupModal id="new-subgroup-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>

    @if (!selectedNode?.subCategory) {
    <h3>
      {{
        "settings.you-must-first-select-a-subcategory-to-add-a-new-subgroup"
          | transloco
      }}
    </h3>
    } @if (selectedNode?.subCategory) {
    <h1>{{ "settings.create-new-subgroup" | transloco }}</h1>
    } @if (selectedNode?.subCategory) {
    <form (ngSubmit)="createSubgroup()">
      <div>
        <label>{{ "settings.subgroup-name" | transloco }}</label>
        <input
          type="text"
          [(ngModel)]="newSubgroupName"
          name="newSubgroupName"
        />
      </div>
      <div>
        <label>{{ "settings.subgroup-hash" | transloco }}</label>
        <input
          type="text"
          [(ngModel)]="newSubgroupHash"
          name="newSubgroupHash"
        />
      </div>
      <div>
        <label>{{ "settings.subgroup-order" | transloco }}</label>
        <input
          type="number"
          min="1"
          [(ngModel)]="newSubGroupOrder"
          name="newSubGroupOrder"
        />
      </div>
      <div class="actions">
        <span class="go-back cancel">{{ "settings.cancel" | transloco }}</span>
        <button
          class="ui primary background button"
          [ngClass]="{ disabled: !newSubgroupName }"
        >
          {{ "settings.create" | transloco }}
        </button>
      </div>
    </form>
    } @if (!selectedNode?.subCategory) {
    <div class="actions">
      <div class="ui primary background deny button">
        {{ "settings.continue" | transloco }}
      </div>
    </div>
    }
  </div>

  <div #selectTabQuestionModal id="select-tab-question" class="ui tiny modal">
    <div class="icon modal-close close"></div>

    <div class="header">
      <h2>{{ "settings.select-question" | transloco }}</h2>
      <div class="search">
        <div class="ui left icon input">
          <i class="search icon"></i>
          <input
            type="text"
            [(ngModel)]="selectTabQuestionSearch"
            placeholder="{{ 'settings.search-questions' | transloco }}"
          />
        </div>
      </div>
    </div>

    @if (selectedNode?.subCategory) {
    <div class="list">
      @for (question of questions|keyWord:['question']:selectTabQuestionSearch;
      track question) { @if (question.isTab && canAddQuestion(question)) {
      <div class="item" (click)="selectTabQuestion(question)">
        <div>
          {{ question?.question }}
          <div class="question-type">{{ getQuestionType(question) }}</div>
        </div>
        <div class="mandatory">
          {{ question?.mandatory ? "Mandatory" : "Optional" }}
          <span
            class="dot"
            [ngClass]="{
              mandatory: question.mandatory,
              optional: !question.mandatory
            }"
          ></span>
        </div>
      </div>
      } }
    </div>
    }
  </div>

  <div
    #addQuestionToSubgroupModal
    id="add-question-to-subgroup-modal"
    class="ui tiny modal"
  >
    <div class="icon modal-close close"></div>

    <div class="header">
      <h2>{{ "settings.select-question" | transloco }}</h2>
      <div class="search">
        <div class="ui left icon input">
          <i class="search icon"></i>
          <input
            type="text"
            [(ngModel)]="addSubgrupQuestionSearch"
            placeholder="Search Questions"
          />
        </div>
      </div>
    </div>

    @if (selectedNode?.subGroup) {
    <div class="list">
      @for (question of questions|keyWord:['question']:addSubgrupQuestionSearch;
      track question) { @if (canAddQuestion(question)) {
      <div class="item" (click)="addQuestionToSubgroup(question)">
        <div>
          {{ question?.question }}
          <div class="question-type">{{ getQuestionType(question) }}</div>
        </div>
        <div class="mandatory">
          {{ question?.mandatory ? "Mandatory" : "Optional" }}
          <span
            class="dot"
            [ngClass]="{ 'top-level': question.topLevel }"
          ></span>
        </div>
      </div>
      } }
    </div>
    }
  </div>

  <div #editModal id="edit-modal" class="ui tiny modal edit">
    <div (click)="reset()" class="icon modal-close close"></div>

    @if (errorMessage) {
    <div class="content">
      <div class="icon" [ngClass]="{ 'red-error': errorMessage }"></div>
      <h4>{{ errorMessage ? errorMessage : "" }}</h4>
    </div>
    } @if (!errorMessage) {
    <h1>
      {{
        "settings.edit-selected-node-type"
          | transloco: { type: selectedNode?.type }
      }}
    </h1>
    } @if (selectedNode && !errorMessage) {
    <form>
      @if (selectedNode.category) {
      <div>
        <label>{{ "settings.category-name" | transloco }}</label>
        <input
          type="text"
          [(ngModel)]="selectedNode.category.newCategoryName"
          name="name"
        />
      </div>
      <div>
        <label>{{ "settings.category-order" | transloco }}</label>
        <input
          type="number"
          min="1"
          [(ngModel)]="selectedNode.category.newCategoryOrder"
          name="order"
        />
      </div>
      } @if (selectedNode.subCategory) {
      <div>
        <label>{{ "settings.subcategory-name" | transloco }}</label>
        <input
          type="text"
          [(ngModel)]="selectedNode.subCategory.newSubCategoryName"
          name="name"
        />
      </div>
      <div>
        <label>{{ "settings.order" | transloco }}</label>
        <input
          type="number"
          min="1"
          [(ngModel)]="selectedNode.subCategory.newOrder"
          name="order"
        />
      </div>
      <div class="field" [formGroup]="searchForm">
        <label class="label-heading">Category</label>
        <mat-select
          class="selection form-control small"
          formControlName="newCategory"
        >
          @for (option of newCategoryOptions; track option) {
          <mat-option [value]="option.value">
            {{ option.name }}
          </mat-option>
          }
        </mat-select>
      </div>
      } @if (selectedNode.subGroup) {
      <div>
        <label>{{ "settings.subgroup-name" | transloco }}</label>
        <input
          type="text"
          [(ngModel)]="selectedNode.subGroup.newSubGroupName"
          name="name"
        />
      </div>
      <div>
        <label>{{ "settings.subgroup-hash" | transloco }}</label>
        <input
          type="text"
          [(ngModel)]="selectedNode.subGroup.newSubGroupHash"
          name="hash"
        />
      </div>
      <div>
        <label>{{ "settings.subgroup-order" | transloco }}</label>
        <input
          type="number"
          min="1"
          [(ngModel)]="selectedNode.subGroup.newSubGroupOrder"
          name="order"
        />
      </div>
      @if (!subgroupContainsTabQuestion) {
      <div>
        <div class="field" [formGroup]="searchForm">
          <label class="label-heading">Subcategory</label>
          <mat-select
            class="selection form-control small"
            formControlName="newSubCategory"
          >
            @for (option of newSubCategoryOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.name }}
            </mat-option>
            }
          </mat-select>
        </div>
      </div>
      } } @if (selectedNode.question) {
      <div>
        <label>{{ "settings.order" | transloco }}</label>
        <input
          type="number"
          min="1"
          [(ngModel)]="selectedNode.question.newQuestionOrder"
          name="order"
        />
      </div>
      @if (!isColumnQuestion) {
      <div>
        <div class="field" [formGroup]="searchForm">
          <label class="label-heading">Subgroup</label>
          <mat-select
            class="selection form-control small"
            formControlName="newSubGroup"
          >
            @for (option of newSubGroupOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.name }}
            </mat-option>
            }
          </mat-select>
        </div>
      </div>
      } }
      <div class="actions">
        <span class="go-back deny cancel">{{
          "settings.cancel" | transloco
        }}</span>
        @if (selectedNode.category) {
        <button
          class="ui primary background approve button"
          [ngClass]="{ disabled: !selectedNode?.category?.newCategoryName }"
        >
          {{ "settings.continue" | transloco }}
        </button>
        } @if (selectedNode.subCategory) {
        <button
          class="ui primary background approve button"
          [ngClass]="{
            disabled: !selectedNode?.subCategory?.newSubCategoryName
          }"
        >
          {{ "settings.continue" | transloco }}
        </button>
        } @if (selectedNode.subGroup) {
        <button
          class="ui primary background approve button"
          [ngClass]="{ disabled: !selectedNode?.subGroup?.newSubGroupName }"
        >
          {{ "settings.continue" | transloco }}
        </button>
        } @if (selectedNode.question) {
        <button class="ui primary background approve button">
          {{ "settings.continue" | transloco }}
        </button>
        }
      </div>
    </form>
    }
  </div>

  <div #confirmDeleteModal id="confirm-delete-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>

    <div class="content">
      <h3>{{ "settings.are-you-sure-you-want-to-remove-this" | transloco }}</h3>
    </div>

    <div class="actions">
      <span class="go-back cancel">{{ "settings.cancel" | transloco }}</span>
      <div class="ui primary background approve button">
        {{ "settings.yes-remove" | transloco }}
      </div>
    </div>
  </div>
</div>

@if (!isReady) {
<div class="ui active inverted dimmer">
  <div class="ui large loader"></div>
</div>
}
